import { toNumberOrNull } from '@/lib/number';

/**
 * A Clear-to-bottom reading (#374) stores no transparency. For display only (#396) it stands at
 * that same reading's own pond depth, depth_m x 100; nothing here is ever saved or sent back,
 * and no other round's depth is borrowed.
 */
export function clearDepthCm(depthM: number | string | null | undefined): number | null {
  const depth = toNumberOrNull(depthM);
  return depth == null || depth <= 0 ? null : Math.round(depth * 100);
}

/** The grid cell's caption under "Clear" when that slot has no depth, and the phone row's wording: why no number is shown or plotted. */
export const CLEAR_NO_DEPTH_CAPTION = 'no depth: not plotted';
export const CLEAR_NO_DEPTH_ROW = 'Clear · no depth';

/** "Clear · 140 cm", or "Clear" when that reading has no depth. `unit: false` drops " cm" for tight spots ("Clear · 140"). */
export function clearText(depthM: number | string | null | undefined, { unit = true }: { unit?: boolean } = {}): string {
  const cm = clearDepthCm(depthM);
  return cm === null ? 'Clear' : `Clear · ${cm}${unit ? ' cm' : ''}`;
}
